import React from 'react';

import { MANDATO_LISTING_TYPE } from '../../config/configListing';
import UroboroxListingCard from '../UroboroxListingCard/UroboroxListingCard';
import MandatoListingCard from '../MandatoListingCard/MandatoListingCard';

/**
 * FASE2-BUSCADOR-3c — Elige la tarjeta que le toca a cada tipo de anuncio.
 *
 * Existe para que la decisión viva en UN sitio. Cuando la tarjeta del mandato
 * se creó, la bifurcación se escribió a mano en el listado del buscador y se
 * quedó fuera de "Mis anuncios", del perfil público y de la portada: los
 * mandatos salían allí con la plantilla del anuncio de venta, es decir, con
 * las celdas vacías y un icono de ubicación sin provincia.
 *
 * Cualquier pantalla que pinte un anuncio del que no controla el tipo debe
 * usar este componente y no UroboroxListingCard directamente.
 *
 * `variant` se pasa tal cual a las dos tarjetas, que entienden las mismas:
 *   - 'default': la tarjeta entera enlaza a la ficha.
 *   - 'owner':   no enlaza; lleva al pie un enlace para editar el anuncio.
 */
const ListingCardByType = props => {
  const { listing, ...rest } = props;
  const esMandato = listing?.attributes?.publicData?.listingType === MANDATO_LISTING_TYPE;
  return esMandato ? (
    <MandatoListingCard listing={listing} {...rest} />
  ) : (
    <UroboroxListingCard listing={listing} {...rest} />
  );
};

export default ListingCardByType;
